/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Total_EventsInputs */



/**
* | output |
* | --- |
* | "Total Events" |
*
* @param {Explorer_Info_Property_Total_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_total_events = /** @type {((inputs?: Explorer_Info_Property_Total_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Total_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Total des evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi totali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всего событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Total de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合計イベント数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Total de eventos")
	return /** @type {LocalizedString} */ ("Total Events")
});